module.exports = __webpack_public_path__ + "img/2025-fusion-straciatella-planning.a7248d5.jpg";